/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Bank } from './Bank';
import {
    BankFromJSON,
    BankFromJSONTyped,
    BankToJSON,
} from './Bank';

/**
 * 
 * @export
 * @interface GetMoneyInBanksOutput
 */
export interface GetMoneyInBanksOutput {
    /**
     * 
     * @type {{ [key: string]: Array<Bank>; }}
     * @memberof GetMoneyInBanksOutput
     */
    banks?: { [key: string]: Array<Bank>; };
    /**
     * 
     * @type {Error}
     * @memberof GetMoneyInBanksOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the GetMoneyInBanksOutput interface.
 */
export function instanceOfGetMoneyInBanksOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetMoneyInBanksOutputFromJSON(json: any): GetMoneyInBanksOutput {
    return GetMoneyInBanksOutputFromJSONTyped(json, false);
}

export function GetMoneyInBanksOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetMoneyInBanksOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'banks': !exists(json, 'banks') ? undefined : json['banks'],
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function GetMoneyInBanksOutputToJSON(value?: GetMoneyInBanksOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'banks': value.banks,
        'error': value.error,
    };
}

